import RequireRole from '@web/app/routes/require-role'
import { lazyRoute } from '@web/app/routes/lazy-route'
import { SettingsRoute } from '@web/shared/constants/routes.constant'
import { EUserRole } from '@web/shared/enums/user/user-role.enum'

import type { RouteObject } from 'react-router'

const SettingsRouter: RouteObject[] = [
  {
    path: SettingsRoute.General,
    lazy: lazyRoute(
      () => import('@web/pages/settings-general/ui/settings-general-page'),
      ({ SettingsGeneralPage }) => SettingsGeneralPage
    )
  },
  {
    path: SettingsRoute.Users,
    lazy: async () => {
      const { Users } = await import('@web/entities/user/ui/users')

      return {
        Component: () => (
          <RequireRole roles={[EUserRole.ADMIN]}>
            <Users />
          </RequireRole>
        )
      }
    }
  },
  {
    path: SettingsRoute.Server,
    lazy: async () => {
      const { SettingsServerPage } = await import(
        '@web/pages/settings-server/ui/settings-server-page'
      )

      return {
        Component: () => (
          <RequireRole roles={[EUserRole.ADMIN]}>
            <SettingsServerPage />
          </RequireRole>
        )
      }
    }
  },
  {
    path: SettingsRoute.DateBase,
    lazy: async () => {
      const { DataBasePage } = await import(
        '@web/pages/settings-data-base/ui/data-base'
      )

      return {
        Component: () => (
          <RequireRole roles={[EUserRole.ADMIN]}>
            <DataBasePage />
          </RequireRole>
        )
      }
    }
  }
]

export default SettingsRouter
